(function () {
  'use strict';
  angular
    .module('flightWatch')
    .controller('FlightCancelCtrl', FlightCancelCtrl);

  function FlightCancelCtrl($uibModalInstance, modalParams) {
    var vm = this;

    vm.model = {
      title: modalParams.title,
      msgCol: modalParams.messages || [],
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close(modalParams.close);
    };

    vm.onYesClick = function(){
      $uibModalInstance.close('YES');
    };

    vm.onNoClick = function(){
      $uibModalInstance.close();
    };
  }
}());
